export default function getComposerMessageTypeName(actionType: string | null | undefined): string {
  if (actionType == null) {
    return '';
  }

  if (actionType.startsWith('email')) {
    return 'Email';
  } else if (actionType.startsWith('slack')) {
    return 'Slack';
  } else if (actionType.startsWith('push')) {
    return 'Push';
  } else if (actionType.startsWith('twilio')) {
    return 'Twilio';
  } else if (actionType.startsWith('webhook')) {
    return 'Webhook';
  } else if (actionType.startsWith('urban_airship')) {
    return 'Urban Airship';
  } else {
    return '';
  }
}
